export default __webpack_public_path__ + "static/media/rating.1c044406.png";